import { PdfStrings } from "../types";

export const en: PdfStrings = {
  frontPage: {
    title: "Thank You for Your Trust",
    description:
      "The work on your equipment has now been completed. You are always welcome to contact us should you have any questions or require further assistance.",
    didYouKnow: {
      title: "Did you know...",
      description: "...that we also do this?\nMeet some of our other customers:",
      link: {
        label: "avs.se/en/customer-case",
        url: "https://avs.se/en/customer-case",
      },
    },
    contactUs: {
      title: "Contact us",
      description: "Any questions or concerns?\nContact us:",
      url: "https://avs.se/en/contact",
    },
    missingSomething: {
      title: "Anything else?",
      description: "Do you need any other equipment?\nVisit our webshop:",
      link: {
        label: "shop.avs.se",
        url: "https://shop.avs.se",
      },
    },
    serviceAndSupport: {
      title: "Service & Support",
      description: "Anything not working as expected?\nContact our support:",
      url: "https://avs.se/en/service",
    },
  },
  orderPage: {
    reportTitle: "Final Report",
    orderSection: "Order",
    orderNumber: "Order no.",
    customer: "Customer",
    address: "Address",
    installations: "Installations",
    serviceRequest: {
      title: "Service Request",
      createServiceRequest: "Create a service request via the QR code or",
      scanQrToSimplify: "To expediate the case - scan the QR code on your equipment",
      clickHere: "click here",
      url: "https://avs.se/en/create-service-case",
    },
    companyDescription:
      "AVS is a total supplier that delivers and installs professional AV solutions for meeting rooms and workplaces, with a focus on quality, service, and user-friendliness.",
  },
  checklistPage: {
    installation: "Installation",
    selfInspection: "Self-Inspection",
    functionCheckDone: "Function check completed",
    documentationDone: "Documentation completed",
  },
  inspectionsSection: {
    title: "Final Inspection",
    withCustomerOnSite: "Final inspection with customer on site",
    withoutCustomerOnSite: "Final inspection without customer on site",
    customerName: "Customer name",
    approvedInstallations: "Approved installations",
    personContacted: "Person contacted",
    phone: "Phone",
    time: "Time",
    comment: "Comment",
  },
  productsSection: {
    title: "Products",
  },
  productDetails: {
    serialNumber: "Serial number",
    macAddress: "MAC address",
    macAddressWifi: "MAC address (WiFi)",
    networkPort: "Network port",
    assetNumber: "Asset number",
    theftMarking: "Theft marking",
    ipAddress: "IP address",
    username: "Username",
    password: "Password",
    firmware: "Firmware",
    other: "Other",
  },
  imagesSection: {
    title: "Photos",
  },
  footer: {
    url: "https://www.avs.se/en/home",
  }
};
